import { Box, Typography, styled } from '@mui/material';
import React from 'react';

const HeroWrapper = styled(Box)(({ theme }) => ({
  backgroundImage: 'url("/images/pricing/pricing-hero-bg.jpg")',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  width: '100%',
  height: '80vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1,
  },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
  maxWidth: '868px',
  textAlign: 'center',
  padding: theme.spacing(4),
  position: 'relative',
  zIndex: 2,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
}));

const HeroTitle = styled(Typography)(({ theme }) => ({
  fontFamily: '"Nohemi", sans-serif !important',
  fontWeight: 600,
  fontSize: '64px',
  lineHeight: '1.1875em',
  letterSpacing: '1%',
  color: '#FFFFFF',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    fontSize: '48px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '36px',
  },
}));

const HeroSubtitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, sans-serif !important',
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: '1.4em',
  color: '#FFFFFF',
  marginBottom: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    fontSize: '16px',
  },
}));

const PricingHeroSection: React.FC = () => (
  <HeroWrapper>
    <ContentContainer>
      <HeroTitle>Simple Pricing for Every Property Owner</HeroTitle>
      <HeroSubtitle>
        Start your 30-day free trial with full access to all features. No credit card required.
      </HeroSubtitle>
    </ContentContainer>
  </HeroWrapper>
);

export default PricingHeroSection;
